import { combineEpics, Epic, ofType } from 'redux-observable'
import { of } from 'rxjs'
import {
  map,
  mergeMap,
  switchMap,
  takeUntil,
  throttleTime
} from 'rxjs/operators'
import { actionTypesToTriggerSaving } from '../../config.ts'
import { getHub } from '../../helpers/hub'
import { addLogItem } from '../log/actions'
import { setUserPreferences } from '../userPreferences/actions'
import { initialState as initialPreferences } from '../userPreferences/reducer'
import { forceReload } from '../ws/actions'
import { HandleWindowSettingsAction, loadWindowSettings } from './actions'
import { defaultBackendSettings, settingsObject } from './helpers'
import { WindowSettingsDto } from './types.ts'

const loadWindowSettingsEpic: Epic = (action$) =>
  action$.pipe(
    ofType('settings.handleWindowSettings'),
    switchMap(() =>
      getHub()
        .invoke('GetWindowSettings')
        .pipe(
          map((settings) => loadWindowSettings(settings as WindowSettingsDto))
        )
    )
  )

const saveWindowSettingsEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('settings.handleWindowSettings'),
    switchMap((action: HandleWindowSettingsAction) => {
      return action$.pipe(
        ofType(...actionTypesToTriggerSaving),
        throttleTime(1500),
        switchMap(() =>
          getHub()
            .invoke('SaveWindowSettings', settingsObject(state$))
            .pipe(
              map(() => addLogItem(`Saving settings because ${action.type}.`))
            )
        ),
        takeUntil(action$.ofType('ws.force-reload'))
      )
    })
  )

const clearSettingsEpic: Epic = (action$) =>
  action$.pipe(
    ofType('settings.clearSettings'),
    mergeMap(() => {
      return getHub().invoke('SaveWindowSettings', defaultBackendSettings)
    }),
    mergeMap(() =>
      of(
        setUserPreferences(initialPreferences.userPreferences),
        addLogItem('clearing settings'),
        forceReload()
      )
    )
  )

export default combineEpics(
  clearSettingsEpic,
  loadWindowSettingsEpic,
  saveWindowSettingsEpic
)
